import styled from 'styled-components';

// Testimonials Section
export const TestimonialsSection = styled.section`
  position: relative;
  width: 100%;
  background-color: #1B170C;
  overflow: hidden;
  padding: 80px 0 64px 0;

  @media (max-width: 768px) {
    padding: 60px 0 48px 0;
  }

  @media (max-width: 480px) {
    padding: 50px 0 40px 0;
  }
`;

export const TestimonialsContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 32px;
`;

export const TestimonialsTitle = styled.h2`
  font-family: 'Mulish', 'Sora', 'Helvetica', sans-serif;
  font-weight: 700;
  color: #FFFFFF;
  font-size: 48px;
  line-height: 1.2;
  text-align: center;
  margin-bottom: 32px;
  letter-spacing: 0;

  @media (max-width: 1024px) {
    font-size: 42px;
  }

  @media (max-width: 768px) {
    font-size: 36px;
    line-height: 1.3;
  }

  @media (max-width: 480px) {
    font-size: 32px;
  }

  @media (max-width: 360px) {
    font-size: 28px;
  }

  @media (min-width: 1024px) {
    margin-bottom: 64px;
  }
`;

export const TestimonialsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  width: 100%;
  align-items: start;

  @media (min-width: 640px) {
    align-items: stretch;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    padding: 0;
  }

  @media (min-width: 1024px) {
    padding: 0;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }
`;

export const TestimonialCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: #1B170C;
  border-radius: 8.04px;
  border: 0.75px solid #5B5441;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  }

  @media (min-width: 1024px) {
    &:nth-child(n+10) {
      display: none;
    }
  }

  @media (min-width: 640px) and (max-width: 1023px) {
    &:nth-child(n+7) {
      display: none;
    }
  }

  @media (max-width: 639px) {
    &:nth-child(n+5) {
      display: none;
    }
  }
`;

export const TestimonialCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5.03px;
  padding: 12px;
  height: auto;
  justify-content: flex-start;

  @media (min-width: 768px) {
    height: 100%;
    justify-content: center;
  }

  @media (min-width: 640px) {
    padding: 16px;
  }

  @media (min-width: 1024px) {
    padding: 24px;
  }
`;

export const TestimonialCardInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 0 0 auto;

  @media (min-width: 768px) {
    flex: 1;
  }

  @media (min-width: 640px) {
    gap: 12px;
  }

  @media (min-width: 1024px) {
    gap: 12.06px;
  }
`;

export const TestimonialHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TestimonialUserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 6.53px;
`;

export const TestimonialUserDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6.03px;
`;

export const TestimonialUserName = styled.div`
  margin-top: -0.50px;
  font-family: 'Inter', 'Helvetica', sans-serif;
  font-weight: 600;
  color: #F9FAFB;
  font-size: 20px;
  letter-spacing: -0.20px;
  line-height: normal;

  @media (min-width: 640px) {
    font-size: 18px;
  }

  @media (min-width: 1024px) {
    font-size: 20px;
  }
`;

export const TestimonialUserLocation = styled.div`
  font-family: 'Inter', 'Helvetica', sans-serif;
  font-weight: 500;
  color: #E8E8E8;
  font-size: 16px;
  letter-spacing: -0.16px;
  line-height: normal;

  @media (min-width: 640px) {
    font-size: 14px;
  }

  @media (min-width: 1024px) {
    font-size: 16px;
  }
`;

export const TestimonialQuoteIcon = styled.img`
  width: 20px;
  height: 16px;
  margin-right: -0.38px;
  flex-shrink: 0;
  opacity: 0.6;

  @media (min-width: 1024px) {
    width: 20px;
    height: 16px;
  }
`;

export const TestimonialText = styled.div`
  width: 100%;
  font-family: 'Mulish', 'Helvetica', sans-serif;
  font-weight: 400;
  font-style: italic;
  color: rgba(232, 232, 232, 0.9);
  font-size: 16px;
  letter-spacing: -0.18px;
  line-height: normal;

  @media (min-width: 640px) {
    font-size: 16px;
  }

  @media (min-width: 1024px) {
    font-size: 18px;
  }
`;
